import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CalculatorResult } from '../../../../models/analysis/solar-calculator-result';
import { inOutAnimation } from '../../../../animations';
import { CalculatorResultWrapper } from '../../../../models/analysis/calculator-result-wrapper';
import { PowerPlant } from '../../model/power-plant';
import { YearlySpendingResult } from '../../value-components/yearly-spendings/yearly-spending.component';
import { PriceCountry } from '../../../../models/price/price';

@Component({
  selector: 'psc-monthly-manual-result',
  templateUrl: './monthly-manual-result.component.html',
  animations: [inOutAnimation({})],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonthlyManualResultComponent {
  @Input() calculatorResultWrapper: CalculatorResultWrapper;
  @Input() powerPlant: PowerPlant;

  get solarCalculatorResult(): CalculatorResult {
    return this.calculatorResultWrapper.result;
  }
  get yearlySpending(): YearlySpendingResult[] {
    return this.calculatorResultWrapper?.result?.yearlySpending || [];
  }

  selectedMonth: number;
  protected readonly PriceCountry = PriceCountry;
}
